import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { ProjectResource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  activateProjectResource(
    request: Boundaries["activateProjectResource"]["request"],
  ): void;
}

function useActivateProjectResource(
  projectResource: Identifiable<ProjectResource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isDisableProjectResourceRequestPending(projectResource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isDisableProjectResourceRequestSuccess(projectResource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isDisableProjectResourceRequestFailure(projectResource),
    ),
    activateProjectResource: core.activateProjectResource,
  };
}

export { useActivateProjectResource };
